import React from 'react';

class Link extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
		if (this.props.value)
			return (
				<React.Fragment>
					<a style={this.props.style} 
						target={ this.props.targetBlank ? "_blank" : ""}
						href={this.props.value.url} 
						onClick={e => this.handleClick(e)}>
							{this.props.value.title}
					</a>
				</React.Fragment>)

		return null
	}
}

Link.defaultProps = {
    targetBlank: false
}

export default Link;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Link.js